<div class="container-sm">
  <ng-container *ngIf="filters$ | async as filters">
    <!-- Only show filters, if there is more than one -->
    <ng-container *ngIf="filters.length > 1">
      <!-- mobile filters -->
      <mb-dropdown
        [options]="filters"
        class="contain"
        [class.display-inline-flex]="collapseOnDesktop"
        [hideLabel]="false"
        [class.active]="activeFilter$.value !== 'all'"
        (selectionChanged)="setFilter($event.value)"
      ></mb-dropdown>
      <!-- tabbed filters -->
      <ul class="tab-navigation copy-l" [class.hide]="collapseOnDesktop">
        <li
          *ngFor="let filter of filters"
          class="tab-navigation-item"
          [class.active]="activeFilter$.value === filter.value"
          (click)="setFilter(filter.value)"
        >
          {{ filter.label | translate }}
        </li>
      </ul>
    </ng-container>
  </ng-container>
</div>

<ng-container *ngIf="presenters$ | async as presenter">
  <div class="container-sm collapse-sm">
    <div class="card-list">
      <mb-contact-person-card
        class="column-card col-12 col-lg-6"
        *ngFor="let expert of presenter"
        [fullname]="expert.fullname"
        [position]="expert.position"
        [media]="expert.image"
        [initials]="expert.initials"
        [topline]="expert.availabilityPeriod"
        [hideMedia]="false"
      ></mb-contact-person-card>
    </div>
  </div>
</ng-container>
